export class FileModel {
    ID: number;
    FILENAME: string;
    FILEDATA: any;
    CreatedDate: Date;
    client_no?: number;
    pet_no?: number;
    type?: string;

    constructor(
        ID: number,
        FILENAME: string,
        FILEDATA: any,
        CreatedDate: Date,
        client_no?: number,
        pet_no?: number,
        type?: string
    ){
        this.ID = ID;
        this.FILENAME = FILENAME;
        this.FILEDATA = FILEDATA;
        this.CreatedDate = CreatedDate;
        this.client_no = client_no;
        this.pet_no = pet_no;
        this.type = type;
    }

}